module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "core"
    }
  }, [_vm._m(0), _vm._v(" "), _c('header', [_c('div', {
    staticClass: "cover"
  }, [_c('section', [_c('span', {
    class: _vm.active === 'N+1' ? 'active' : '',
    on: {
      "click": function($event) {
        _vm.active = 'N+1'
      }
    }
  }, [_vm._v("N+1解决方案")]), _vm._v(" "), _c('span', {
    class: _vm.active === '1+N' ? 'active' : '',
    on: {
      "click": function($event) {
        _vm.active = '1+N'
      }
    }
  }, [_vm._v("1+N解决方案")])]), _vm._v(" "), (_vm.active === 'N+1') ? _c('footer', [_vm._m(1), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/imgs/portal/case/n+1@2x.png",
      "alt": "img"
    }
  })]) : (_vm.active === '1+N') ? _c('footer', [_vm._m(2), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/imgs/portal/case/1+n@2x.png",
      "alt": "img"
    }
  })]) : _vm._e()])]), _vm._v(" "), (_vm.active === 'N+1') ? _c('div', {
    staticClass: "advantage"
  }, [_vm._m(3)]) : (_vm.active === '1+N') ? _c('div', {
    staticClass: "advantage"
  }, [_vm._m(4)]) : _vm._e(), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "form"
  }, [_c('div', {
    staticClass: "cover"
  }, [_c('h1', [_vm._v("推荐核心企业使用供应链金融方案，做货款结算的主人")]), _vm._v(" "), _c('portal-form', {
    attrs: {
      "from": "case-chain",
      "roleType": _vm.active
    }
  }), _vm._v(" "), _vm._m(6)], 1)]), _vm._v(" "), _c('portal-footer', {
    attrs: {
      "page": "download-home",
      "roleType": _vm.active
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('div', {
    staticClass: "cover"
  }, [_c('h1', [_vm._v("供应商/经销商")]), _vm._v(" "), _c('h2', [_vm._v("帮助供应商／经销商盘活沉淀在供应链中的资产"), _c('br'), _vm._v("让企业平等获得金融服务")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contant"
  }, [_c('h2', [_vm._v("N+1解决方案")]), _vm._v(" "), _c('h3', [_vm._v("供应商通过群星金融将与核心企业的应收账款转让给金融机构，从而获得新的融资渠道，降低融资成本。金融机构依据核心企业信用状况来确定成本，核心企业获得更稳定的供应链和额外财务收益。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contant"
  }, [_c('h2', [_vm._v("1+N解决方案")]), _vm._v(" "), _c('h3', [_vm._v("经销商通过群星金融将与核心企业的应付账款转让给金融机构，延长付款账期，缓解资金压力，缓解赊销负担，同时提高核心企业资金周转率，增加经营性现金。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cover"
  }, [_c('h1', [_vm._v("供应商可以通过该方案改善如下状况")]), _vm._v(" "), _c('div', {
    staticClass: "list"
  }, [_c('div', [_c('strong', [_vm._v("01")]), _vm._v(" "), _c('span', [_vm._v("提升供应链竞争力")])]), _vm._v(" "), _c('div', [_c('strong', [_vm._v("02")]), _vm._v(" "), _c('span', [_vm._v("掌握供应链话语权")])]), _vm._v(" "), _c('div', [_c('strong', [_vm._v("03")]), _vm._v(" "), _c('span', [_vm._v("获得财务收益")])]), _vm._v(" "), _c('div', [_c('strong', [_vm._v("04")]), _vm._v(" "), _c('span', [_vm._v("更好的资本市场表现")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cover"
  }, [_c('h1', [_vm._v("经销商可以通过该方案改善如下状况")]), _vm._v(" "), _c('div', {
    staticClass: "list"
  }, [_c('div', [_c('strong', [_vm._v("01")]), _vm._v(" "), _c('span', [_vm._v("解除赊销负担")])]), _vm._v(" "), _c('div', [_c('strong', {
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_vm._v("02")]), _vm._v(" "), _c('span', [_vm._v("延长账期"), _c('br'), _vm._v("缓解资金压力")])]), _vm._v(" "), _c('div', [_c('strong', {
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_vm._v("03")]), _vm._v(" "), _c('span', [_vm._v("扩大销售规模"), _c('br'), _vm._v("增强议价能力")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "case"
  }, [_c('div', {
    staticClass: "cover"
  }, [_c('h1', [_vm._v("我们的案例")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/imgs/portal/case/anli1@2x.png",
      "alt": "img"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/imgs/portal/case/anli2@2x.png",
      "alt": "img"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/imgs/portal/case/anli3@2x.png",
      "alt": "img"
    }
  }), _vm._v(" "), _c('h2', [_vm._v("……")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', [_vm._v("此类个人信息仅用于注册，合同和联系目的，绝不会与第三方共享。"), _c('br'), _vm._v("有关我们的更多信息以及我们如何保护您的个人信息，请参阅我们的"), _c('a', {
    attrs: {
      "href": "/pdf/tips.pdf",
      "download": "隐私声明"
    }
  }, [_vm._v("隐私声明")]), _vm._v("。")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-2071082e"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/portal/components/case/Chain.vue
// module id = 1278
// module chunks = 26